import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { MicrosoftProfile } from "../models/MicrosoftProfile";

@Injectable({
    providedIn: 'root'
})
export class MicrosoftGraphService {

    constructor(private http: HttpClient) {

    }

    getUserProfile(): Observable<MicrosoftProfile> {
        return this.http.get<MicrosoftProfile>('https://graph.microsoft.com/v1.0/me');
    }

    getUserPhoto(): Observable<Blob> {
        return this.http.get('https://graph.microsoft.com/v1.0/me/photo/$value', {
            responseType: 'blob'
        });
    }

}
